<template>
  <modal
  name="confirmation-modal"
  height="auto"
  :pivot-y="0.3"
  :adaptive="true"
  :width="428"
  @before-open="beforeOpen">
    <div class="ConfirmationModal__container">
      <div v-if="params.title"
           class="ConfirmationModal__title">
        {{ params.title || '' }}
      </div>
      <div v-if="params.description"
           class="ConfirmationModal__description">
        {{ params.description || '' }}
      </div>
      <div v-if="params.rememberOption"
           class="ConfirmationModal__remember-box">
        <div class="checkbox">
          <input
          type="checkbox"
          id="remember_confirmation"
          v-model="params.remember"
          v-on:change="remember">
          <label
          class="form-value"
          for="remember_confirmation">
            Don't show this anymore
            <i class="icon-ic_tick"></i>
          </label>
        </div>
      </div>
      <div class="form-actions centered"
           v-if="params.actions">
        <a v-for="(action, i) in params.actions"
           :key="i"
           :class="action.class"
           @click.stop="click(i, $event)">
          {{ action.label }}
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    name: 'ConfirmationModal',
    data() {
      return {
        params: {}
      };
    },
    methods: {
      beforeOpen(event) {
        this.params = event.params || {};
        if (this.params.rememberOption) {
          this.params.remember = localStorage.getItem(this.params.id);
        }
      },
      click(i, event) {
        const action = this.params.actions[i];
        if (typeof action.handler === 'function') {
          action.handler(i, event);
        }
        this.$modal.hide('confirmation-modal');
      },
      remember() {
        if (this.params.remember) {
          localStorage.setItem(this.params.id, true);
        } else {
          localStorage.removeItem(this.params.id);
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  @import 'style.scss';
</style>



// WEBPACK FOOTER //
// confirmation.modal.vue?21b9b8b8